<template>
    <div class="form-content">
        <div class="mb-3 mb-md-4">
            <label class="label-text mb-2" for="logoInput">Logotipo</label>
            <CustomFileInput
                id="logoInput"
                accept="image/*"
                :info-text="`Tamanho recomendado: ${selectedLogo.width}x${selectedLogo.height}px.`"
                @update:modelValue="$emit('logo-selected', $event)"
                v-model="logoFile"
            />
        </div>

        <div
            class="flex justify-content-between align-items-center py-2 mb-3 mb-md-4"
        >
            <label class="label-text mr-2" for="toggleWorkLoad"
                >Exibir carga horária</label
            >
            <CustomToggle
                id="toggleWorkLoad"
                @change="$emit('toggle-work-load', $event)"
                v-model="workLoadEnabledData"
            />
        </div>

        <div
            class="flex justify-content-between align-items-center py-2 mb-3 mb-md-4"
        >
            <label class="label-text mr-2" for="toggleConclusionDate"
                >Exibir data de conclusão</label
            >
            <CustomToggle
                id="toggleConclusionDate"
                @change="$emit('toggle-conclusion-date', $event)"
                v-model="conclusionDateEnabledData"
            />
        </div>

        <div
            class="flex justify-content-between align-items-center py-2 mb-3 mb-md-4"
        >
            <label class="label-text mr-2" for="toggleSignature"
                >Exibir assinatura</label
            >
            <CustomToggle
                id="toggleSignature"
                @change="$emit('toggle-signature', $event)"
                v-model="signatureEnabledData"
            />
        </div>

        <div class="mb-3">
            <label class="label-text mb-2" for="signatureNameInput"
                >Nome da assinatura</label
            >
            <input
                type="text"
                id="signatureNameInput"
                class="custom-form-input"
                placeholder="Já vem o nome do administrador"
                @change="onChangeSignatureName"
                v-model="signatureName"
            />
        </div>

        <div class="mb-3">
            <label class="label-text mb-2" for="logoInput"
                >Foto da assinatura</label
            >
            <CustomFileInput
                id="signatureInput"
                accept="image/*"
                :info-text="`Tamanho recomendado: ${selectedSignature.width}x${selectedSignature.height}px.`"
                @update:modelValue="$emit('signature-selected', $event)"
                v-model="signatureFile"
            />
        </div>
    </div>
</template>

<script>
    import CustomFileInput from '@/components/Form/CustomFileInput.vue';
    import CustomToggle from '@/components/Form/CustomToggle.vue';

    import { debounce } from 'lodash';

    export default {
        name: 'FormContent',
        components: {
            CustomFileInput,
            CustomToggle,
        },
        emits: [
            'logo-selected',
            'toggle-work-load',
            'toggle-conclusion-date',
            'toggle-signature',
            'signature-name-changed',
            'signature-selected',
        ],
        props: {
            selectedLogo: {
                type: Object,
                default: () => ({ file: null, width: 300, height: 180 }),
                validator: (val) => {
                    return (
                        typeof val === 'object' &&
                        ('file' in val
                            ? val.file === null || val.file instanceof File
                            : true) &&
                        typeof val.width === 'number' &&
                        typeof val.height === 'number'
                    );
                },
            },
            workLoadEnabled: {
                type: Boolean,
                default: false,
            },
            conclusionDateEnabled: {
                type: Boolean,
                default: false,
            },
            selectedSignature: {
                type: Object,
                default: () => ({
                    enabled: false,
                    text: '',
                    file: null,
                    width: 300,
                    height: 100,
                }),
                validator: (val) => {
                    return (
                        typeof val === 'object' &&
                        ('file' in val
                            ? val.file === null || val.file instanceof File
                            : true)
                    );
                },
            },
        },
        data() {
            return {
                logoFile: this.selectedLogo.finalPath ? this.selectedLogo.finalPath : this.selectedLogo.file,
                workLoadEnabledData: this.workLoadEnabled,
                conclusionDateEnabledData: this.conclusionDateEnabled,
                signatureEnabledData: this.selectedSignature.enabled,
                signatureName: this.selectedSignature.text,
                signatureFile: this.selectedSignature.finalPath ? this.selectedSignature.finalPath : this.selectedSignature.file,
            };
        },
        methods: {
            onChangeSignatureName: debounce(function (event) {
                const value = event.target.value;
                this.$emit('signature-name-changed', value);
            }, 300),
        },
    };
</script>

<style scoped>
    .form-content {
        padding: 12px;
        max-height: 76svh;
        overflow: auto;
    }

    .label-text {
        display: block;
        font-size: 14px;
        font-weight: 600;
        margin: 0;
    }

    .custom-form-input {
        width: 100%;
        padding: 8px 12px;
        border: 1px solid #d6d8de;
        border-radius: 4px;
        font-size: 0.875rem;
        color: #080919;
    }

    .custom-form-input:focus {
        border-color: #3a3a3a;
        outline: none;
    }

    @media screen and (min-width: 768px) {
        .form-content {
            padding: 20px 24px;
        }

        .custom-form-input {
            padding: 12px 16px;
        }
    }

    .dark .custom-form-input {
        background-color: #2c2c2c;
        color: #ffffff;
        border: 1px solid #444444;
    }

    .dark .custom-form-input:focus {
        border-color: #ffffff;
    }
</style>
